// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  background: none;
  outline: none;
  margin: 0;
  border: none;
  cursor: pointer;
  color: inherit;
}

a {
  color: black;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/style/reset.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B","sourcesContent":["button {\n  background: none;\n  outline: none;\n  margin: 0;\n  border: none;\n  cursor: pointer;\n  color: inherit;\n}\n\na {\n  color: black;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
